import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { formatNum } from "@/lib/api";

export const UGCCard = ({ item, index }) => {
  const isNew = item.item_created_utc && Date.now() - new Date(item.item_created_utc).getTime() < 3 * 24 * 3600 * 1000;
  return (
    <motion.a
      href={`https://www.roblox.com/catalog/${item.asset_id}`} target="_blank" rel="noreferrer" data-testid={`ugc-card-${item.asset_id}`}
      initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.05, ease: [0.22, 1, 0.36, 1] }}
      className="group relative block border border-border bg-card overflow-hidden hover:border-volt transition-colors duration-300"
    >
      <div className="relative aspect-square overflow-hidden bg-secondary">
        <img src={item.thumbnail_url} alt={item.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ease-out" />
        {isNew && <span className="absolute top-2 left-2 bg-volt text-white font-mono text-[9px] tracking-[0.15em] uppercase px-2 py-1">New</span>}
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-md border border-white/10 px-2 py-1">
          <Heart className="w-3 h-3 text-volt" fill="currentColor" />
          <span className="font-mono text-[10px]" data-testid={`ugc-fav-${item.asset_id}`}>{formatNum(item.favorites)}</span>
        </div>
      </div>
      <div className="p-3">
        <div className="font-display font-bold text-sm uppercase tracking-tight truncate">{item.name}</div>
        <div className="flex items-center justify-between mt-1 gap-2">
          <span className="font-mono text-[9px] tracking-[0.1em] uppercase text-muted-foreground truncate">{item.group_name}</span>
          <span className="font-mono text-[10px] text-volt shrink-0">{item.price_text}</span>
        </div>
      </div>
    </motion.a>
  );
};
